import React, { useEffect, useState } from 'react';


import "./OpenAIHealthCheck.css";


import { ReactComponent as CloseSymbol } from "assets/icons/close-symbol.svg";

function OpenAIHealthCheck() {
    const [status, setStatus] = useState("");
    const [description, setDescription] = useState("");
    const [hidden, setHidden] = useState(false);

    // * make the call to the status API
    useEffect(() => {
        const openAIStatusCheck = async () => {
            const statusUrl = 'https://status.openai.com/api/v2/status.json';

            try {
                const response = await fetch(statusUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();

                
                setStatus(data.status.indicator);
                setDescription(data.status.description);

            } catch (error) {
                console.error("Failed to retrieve service status:", error);
            }
        };

        openAIStatusCheck();
    }, []);
    
    useEffect(() => {

    });


    // if there is no error don't return anything
    if (status === "none") {
        return false;
    }

    // there is some kind of error, return the component
    return (status !== "none" &&
        (<div className={`open-ai-status ${hidden ? "hidden" : ""}`}>
            <button onClick={() => setHidden(true)} className="close-button">
                <CloseSymbol />
            </button>
            <h2>OpenAI is currently facing technical difficulties, which may affect GustieBot's performance.</h2>
        </div>)
    );
}

export default OpenAIHealthCheck;
